import { useDeviceToken } from "./hooks/core/useFCMToken";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { RouterProvider } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import { router } from "./routes";
import { theme } from "./config/theme";
import { GoogleMapsProvider } from "./shared/components/GoogleMapsProvider";
import { NavigationHistoryProvider } from "./shared/contexts/NavigationHistoryContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "@mantine/core/styles.layer.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "mantine-datatable/styles.layer.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CalendarProvider } from "./contexts/CalendarContext";
import { LocalAuthorityProvider } from "./contexts/LocalAuthorityContext";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: Infinity } },
});

const App = () => {
  useDeviceToken();

  return (
    <MantineProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <DatesProvider>
          <GoogleMapsProvider>
            <NavigationHistoryProvider>
              <CalendarProvider>
                <LocalAuthorityProvider>
                  <ThemeProvider>
                    <Notifications position="top-right" />
                    <RouterProvider router={router} />
                  </ThemeProvider>
                </LocalAuthorityProvider>
              </CalendarProvider>
            </NavigationHistoryProvider>
          </GoogleMapsProvider>
        </DatesProvider>
      </QueryClientProvider>
    </MantineProvider>
  );
};

export default App;
